import { render, staticRenderFns } from "./HotExhibition.vue?vue&type=template&id=9d0c2368&scoped=true"
import script from "./HotExhibition.vue?vue&type=script&lang=js"
export * from "./HotExhibition.vue?vue&type=script&lang=js"
import style0 from "./HotExhibition.vue?vue&type=style&index=0&id=9d0c2368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0c2368",
  null
  
)

export default component.exports